import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    formInline: {},
    userInfo: {}
  },
  // getters: {
  //   formInline: state => state.formInline
  // },
  mutations: {
    // FORE_IN_LINE(state, data) {
    //   state.formInline = data;
    // }
    SET_USERINFO(state, data) {
      state.userInfo = { ...data };
    }
  },
  actions: {
  },
  modules: {
  }
});
